import { Button, Center, Stack, Text } from "@chakra-ui/react";

interface Props {
  refetch: () => void;
}

export function OperationListError({ refetch }: Props) {
  return (
    <Center flex="1" pb="100px">
      <Stack spacing="5px" h="74px" alignItems="center">
        <Text lineHeight="39px" variant="brand">Не удалось загрузить данные</Text>
        <Button
          onClick={refetch}
          h="30px"
          fontSize="sm"
          borderRadius="full"
          colorScheme="brand"
        >
          Повторить попытку
        </Button>
      </Stack>
    </Center>
  );
}
